import sileo from 'sileo';

const JobPostingProfile = new sileo.Model('hqzen', 'job-posting-profile');
const NewClientJobPostings = new sileo.Model('bposeats', 'job-postings');
const LocationConstants = new sileo.Model('hqzen', 'constants');
const JobPostingCountries = new sileo.Model('hqzen', 'countries');
const JobPostingCountriesSub = new sileo.Model('hqzen', 'country-subdivisions');
const JobPostingApply = new sileo.Model('hqzen', 'job-posting-application');
const JobPostingMessageThread = new sileo.Model('hqzen', 'job-posting-message-thread');
const JobPostingMessage = new sileo.Model('hqzen', 'job-posting-message');
const MessageThreadStatus = new sileo.Model('hqzen', 'update-message-thread-status');
const SimpleJobPreference = new sileo.Model('hqzen', 'simple-job-preference');
const MessageThreadJobDetails = new sileo.Model('bposeats', 'message-thread-job-status-details');

const actions = {
    createJobPostingProfile(context, data) {
        return JobPostingProfile.objects.create(data);
    },

    /**
     * Creates a message thread for a job posting.
     * @param {{}} context
     * @param {{job_posting_id:Number,comment:string}} data
     * @returns {Promise<{}>} Returns a promise containing an object of the created comment
     */
    createThread(_context, data) {
        return JobPostingMessageThread.objects.create(data);
    },

    /**
     * Posts a message to a thread.
     * @param {{}} context
     * @param {{job_posting_id:Number,comment:string}} data
     * @returns {Promise<{}>} Returns a promise containing an object of the created comment
     */
     postMessage(_context, data) {
        return JobPostingMessage.objects.create(data);
    },

    /**
     * Posts a message to a thread.
     * @param {{}} context
     * @param {string} pk Job posting primary key
     * @returns {Promise<{}>} Returns a promise containing an object of the created comment
     */
     getMessageThread(_context, filters) {
        return JobPostingMessageThread.objects.filter(filters);
    },

      /**
     * Posts a message to a thread.
     * @param {{}} context
     * @param {{seen:Boolean,read:Boolean,
     * latest_message_read:Number,pk:Number}} data Contains update fields and pk for specific MessageThreadStatus
     * @returns {Promise<{}>} Returns a promise containing an object of the updated status
     */
    updateMessageThreadStatus(_context, data) {
        const form = new FormData();

        form.append('seen', data.seen);
        form.append('read', data.read);
        form.append('latest_message_read', data.latest_message_read);
        return MessageThreadStatus.objects.update({ pk: data.pk },form);
    },

    createClientJobPosting(context, data) {
        const form = new FormData();

        if (!data.schedule_pk) delete data.schedule_pk;
        if (!data.country_id) delete data.country_id;
        if (!data.province_id) delete data.province_id;

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return NewClientJobPostings.objects.create(form);
    },

    async getJobPostingLocationConstants(context, filters) {
        return await LocationConstants.objects.filter(filters).then(data => {
            return data[0];
        });
    },

    async fetchJobPostingCountries(context, filters) {
        return await JobPostingCountries.objects.filter(filters);
    },

    async fetchJobPostingCountrySub(context, filters) {
        return await JobPostingCountriesSub.objects.filter(filters);
    },

    cancelApplicantJobsApplication(context, data) {
        return JobPostingApply.objects.update(data);
    },

    async submitJobPostingApplication(context, data) {
        const formData = new FormData();

        for (let [key, value] of Object.entries(data)) {
            formData.append(key, value);
        }

        return await JobPostingApply.objects.create(formData);
    },

    async updateApplicantAskingSalary(context, data) {
        const form = new FormData();

        for (let [key, value] of Object.entries(data)) {
            form.append(key, value);
        }

        return SimpleJobPreference.objects.update({ 'applicant': data.applicant }, form);
    },

    async createApplicantAskingSalary(context, data) {
        const form = new FormData();

        for (let [key, value] of Object.entries(data)) {
            form.append(key, value);
        }

        return await SimpleJobPreference.objects.create(form);
    },

    getMessageThreadJobDetails(context, pk) {
        return MessageThreadJobDetails.objects.get(pk);
    }
};

export default {
    namespaced: true,
    actions
};
